import { useEffect, useState } from "react";
import api from "@/lib/api";

export const RATING_LABELS = { 1: "No good", 2: "Good", 3: "Amazing" };
export const ratingStyle = (r) =>
  r === 3 ? "bg-primary/15 text-primary border-primary/30"
    : r === 2 ? "bg-primary/10 text-primary border-primary/30"
      : "bg-muted text-muted-foreground border-border";

export const RatingBadge = ({ rating }) => (
  <span className={`inline-flex items-center gap-1 text-xs px-3 py-1 rounded-full border ${ratingStyle(rating)}`}>
    {rating}/3 · {RATING_LABELS[rating]}
  </span>
);

export const ReviewsSection = ({ practitionerId }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/reviews/practitioner/${practitionerId}`).then((r) => setData(r.data));
  }, [practitionerId]);

  if (!data) return null;
  const { reviews, summary } = data;

  return (
    <div className="mt-12" data-testid="reviews-section">
      <div className="flex items-center gap-4 mb-6">
        <h2 className="font-display text-lg md:text-2xl text-foreground">Community reviews</h2>
        {summary.count > 0 && (
          <span className="text-sm text-muted-foreground" data-testid="reviews-summary">
            <span className="text-primary font-medium">{summary.average}</span> / 3 · {summary.count} review{summary.count > 1 ? "s" : ""}
          </span>
        )}
      </div>
      {reviews.length === 0 ? (
        <p className="text-sm text-muted-foreground" data-testid="reviews-empty">No reviews yet — be the first after your session.</p>
      ) : (
        <div className="space-y-4">
          {reviews.map((r) => (
            <div key={r.id} className="silk-card rounded-lg p-5" data-testid={`review-${r.id}`}>
              <div className="flex items-center justify-between mb-2">
                <p className="text-sm text-foreground">{r.seeker_name?.split(" ")[0]} · <span className="text-muted-foreground text-xs">{r.service_name}</span></p>
                <RatingBadge rating={r.rating} />
              </div>
              {r.comment && <p className="text-sm text-muted-foreground leading-relaxed">{r.comment}</p>}
              {r.reply?.text && (
                <div className="mt-3 ml-4 border-l-2 border-primary/30 pl-4">
                  <p className="text-xs text-primary mb-1">Reply from {r.business_name}</p>
                  <p className="text-sm text-muted-foreground">{r.reply.text}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
